import React from 'react';
import { SectionLabel } from '@/components/common/SectionLabel';
import { HOW_IT_WORKS } from '@/data/b2b';

export const HowItWorks = ({ dark = false }) => (
  <section className={dark ? 'navy-gradient' : 'bg-ophir-ivory-soft border-t border-ophir-grey'}>
    <div className="container-ophir py-16 lg:py-24">
      <div className="max-w-2xl mb-12">
        <SectionLabel light={dark}>How procurement works</SectionLabel>
        <h2 className={`mt-5 font-serif text-[28px] sm:text-[36px] leading-tight ${dark ? 'text-white' : 'text-ophir-navy-deep'}`}>A clear, four-step process</h2>
      </div>
      <ol className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {HOW_IT_WORKS.map((s) => (
          <li key={s.n} className={`rounded-2xl border p-6 ${dark ? 'border-white/15 bg-white/[0.04]' : 'border-ophir-grey bg-white shadow-ophir'}`}>
            <span className="inline-flex h-11 w-11 items-center justify-center rounded-full border-2 border-ophir-gold text-ophir-gold-deep font-serif font-bold">{s.n}</span>
            <h3 className={`mt-4 font-serif text-[18px] ${dark ? 'text-white' : 'text-ophir-navy-deep'}`}>{s.title}</h3>
            <p className={`mt-2 text-[14.5px] leading-relaxed ${dark ? 'text-white/70' : 'text-ophir-muted'}`}>{s.body}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);
